import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  & > * {
    margin-bottom: 20px;
  }
  @media (min-width: 426px) {
  }
`;

export const OrdersIframe = styled.iframe`
  border: none;
  height: 99%;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
`;

export const OrdersIframeMob = styled.iframe`
  position: fixed;
  top: 0;
  left: 0;
  border: none;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 999;
`;
